import React from 'react'
import { Tabs } from 'antd'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'

const { TabPane } = Tabs

const SettingsSidebar = () => {
  const navigate = useNavigate()
  const currentLocation = window.location.pathname.split('/')[2]

  return (
    <>
      <Tabs
        type='card'
        defaultActiveKey={currentLocation}
        className='_mb-8'
        onTabClick={(key) => {
          navigate(`/settings/${key}`)
        }}
      >
        <TabPane key='general' tab={<TabTitle>General</TabTitle>} />
        <TabPane key='delivery' tab={<TabTitle>Delivery</TabTitle>} />
        <TabPane
          key='accounts-and-billing'
          tab={<TabTitle>Accounts and Billing</TabTitle>}
        />
        <TabPane
          key='analytics'
          tab={<TabTitle>Marketing and Analytics</TabTitle>}
        />
        <TabPane key='users' tab={<TabTitle>Users</TabTitle>} />
        <TabPane
          key='terms-and-conditions'
          tab={<TabTitle>Terms and Conditions</TabTitle>}
        />
      </Tabs>
    </>
  )
}

const TabTitle = styled.span`
  font-size: 14px !important;
  padding-right: 16px;
`

export default SettingsSidebar
